import { useRef as o } from "react";
import { a as e } from "./isClient-ec947a14.mjs";
const r = () => o(e ? { window, document: window.document, body: window.document.body, isClient: e } : {}).current;
export {
  r as u
};
